import { Observable, catchError, map, of } from 'rxjs';
import { IMaybe } from 'typescript-monads';
import {
  ItkDjangoApi,
  QuestionnaireRequest,
  UnderwritingItem,
} from '../django-api';
import { DrugSearch, ConditionSearch, QuestionnaireSearch } from './interfaces';
import { ToolkitCode } from '@itk/types';

export class ItkDjangoUnderwritingApiV2
  implements DrugSearch, ConditionSearch, QuestionnaireSearch
{
  constructor(
    private readonly api: ItkDjangoApi,
    private readonly toolkit: ToolkitCode,
  ) {}

  drug(query: string): Observable<string[]> {
    return this.api.questionnaire
      .searchDrug({
        name: query,
        toolkit: this.toolkit,
      })
      .pipe(catchError(() => of([])));
  }
  condition(query: string): Observable<string[]> {
    return this.api.questionnaire
      .searchCondition({
        name: query,
        toolkit: this.toolkit,
      })
      .pipe(catchError(() => of([])));
  }
  questionnaire(
    req: QuestionnaireRequest,
  ): Observable<IMaybe<UnderwritingItem>> {
    switch (req.action) {
      case 'get': {
        return this.questionnaireGet(req.session_id ?? '');
      }
      case 'init': {
        return this.questionnaireInit(req);
      }
      case 'answer': {
        return this.questionnaireAnswer(req);
      }
      case 'edit': {
        return this.questionnaireEdit(req);
      }
      case 'previous': {
        return this.questionnairePrev(req);
      }
      default: {
        throw `"${req.action}" is an invalid questionnaire action`;
      }
    }
  }

  questionnaireLoad(schema: object): Observable<object> {
    return this.api.questionnaire.questionnaireLoad(schema);
  }

  questionnaireLoadQuoteId(quoteId: string): Observable<object> {
    return this.api.questionnaire.questionnaireLoadQuoteId(quoteId);
  }

  questionnaireGet(sessionId: string): Observable<IMaybe<UnderwritingItem>> {
    return this.api.questionnaire.questionnaireTraversalGet(sessionId);
  }
  private questionnaireInit(
    req: QuestionnaireRequest,
  ): Observable<IMaybe<UnderwritingItem>> {
    return this.api.questionnaire.questionnaireTraversal(req);
  }
  private questionnaireEdit(
    req: QuestionnaireRequest,
  ): Observable<IMaybe<UnderwritingItem>> {
    return this.api.questionnaire.questionnaireTraversalEdit(req);
  }
  private questionnairePrev(
    req: QuestionnaireRequest,
  ): Observable<IMaybe<UnderwritingItem>> {
    return this.api.questionnaire.questionnaireTraversalPrevious(req);
  }
  private questionnaireAnswer(
    req: QuestionnaireRequest,
  ): Observable<IMaybe<UnderwritingItem>> {
    return this.api.questionnaire.questionnaireTraversalAnswer(req);
  }
  hospitalization(query: string | undefined): Observable<string[]> {
    if (query === undefined) {
      return this.api.autofill.hospitalization({ toolkit: this.toolkit }).pipe(
        map((hospitalizationResponse) => hospitalizationResponse.data),
        catchError(() => of([])),
      );
    }

    return this.api.autofill
      .hospitalization({ data: query, toolkit: this.toolkit })
      .pipe(
        map((hospitalizationResponse) => hospitalizationResponse.data),
        catchError(() => of([])),
      );
  }
  combo(query: UnderwritingItem[]): Observable<string[]> {
    return this.api.autofill.combo(query).pipe(
      map((comboResponse) => comboResponse.data),
      catchError(() => of([])),
    );
  }
}
